import { memo } from "react";

import { QuestionOptionMaxDailyStockNum as Question } from "@/components/features/items/edit/option/_shared/ui/components/max-daily-stock-num";

import { useOptionMaxDailyStockNum } from "./hooks";

export const QuestionOptionMaxDailyStockNum = memo(() => {
	const { maxDailyStockNum, onSetMaxDailyStockNum, isEdited, hasError } = useOptionMaxDailyStockNum();

	return (
		<Question
			maxDailyStockNum={maxDailyStockNum}
			onSetMaxDailyStockNum={onSetMaxDailyStockNum}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
});

QuestionOptionMaxDailyStockNum.displayName = "QuestionOptionMaxDailyStockNum";
